import { useRouterState } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { ANALYTICS_EVENTS, useAnalytics } from "@/lib/analytics";

export function usePageViewAnalytics(locale: string) {
	const location = useRouterState({
		select: (state) => state.resolvedLocation ?? state.location,
	});
	const { capture, canCapture } = useAnalytics();
	const previousPage = useRef<string | null>(null);
	useEffect(() => {
		if (!canCapture) {
			previousPage.current = null;
			return;
		}
		const page = `${locale}:${location.pathname}`;
		if (previousPage.current === page) return;
		previousPage.current = page;
		capture(ANALYTICS_EVENTS.pageView, {
			locale,
			page_url: new URL(location.href, window.location.origin).href,
		});
	}, [canCapture, capture, locale, location.pathname, location.href]);
}
